import { observable, computed, extendObservable, action } from 'mobx';

export default class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  user = null;

  constructor(user) {
    this.user = user;
  }

  @computed get isPage1Valid() {
    const data = this.offerData;
    return !!data.object_type && !!data.surface_area && !!data.object_address;
  }

  @computed get isPage2Valid() {
    return true;
  }

  @computed get isPage3Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      object_type: offerData.object_type || '',
      surface_area: offerData.surface_area || 0,
      objectno: offerData.objectno || '',
      object_address: offerData.object_address || '',
      deed1: offerData.deed1 || '',
      ownership: offerData.ownership || '',
      ownership_share: offerData.ownership_share || '',
      ownership_total: offerData.ownership_total || '',
      ubernommene_lasten: offerData.ubernommene_lasten || null,
      sonstige_gegenleistungen: offerData.sonstige_gegenleistungen || null,
      vat_percentage: offerData.vat_percentage,
      vat_mandate: offerData.vat_mandate || false,
      handover: offerData.handover || '',
      provisionType: offerData.provisionType || 'none',
    });
  }
}

export { SaleEditStore };



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_default/stores/index.js